<template>
    <div class="po-wrapper">
        <div class="po-toolbar">
            <span class="po-btn-refresh" @click="loadItems">{{lang.common.refresh}}</span>
        </div>

        <paged-loading :is-loading="loadingImg" @pagechange="onPageChange" :paging-info="paging">
            <div class="po-orders-list">
                <div class="po-order-card" v-for="item in items">

                    <div class="po-order-header">
                        <h4 class="po-shop-name">{{item.shop.shopName}}</h4>
                        <div class="po-order-meta">
                            <span class="po-order-meta-label">{{lang.order.orderNum}}: {{item.id}}</span>
                            <span class="po-order-meta-date">{{lang.common.date}}: {{item.localCreateDate}}</span>
                        </div>
                    </div>

                    <div class="po-items-section">
                        <div v-for="(orderItem,index) in item.items"
                            class="po-item-row"
                            :order-id="orderItem.id">
                            <div class="po-item-info">
                                <div class="po-item-title-row">
                                    <span class="po-item-index">{{index+1}}.</span>
                                    <span class="po-item-title">{{orderItem.title}}</span>
                                </div>
                                <div class="po-item-props">
                                    <span class="po-item-prop" v-for="pc in orderItem.propCats">
                                        {{pc.parent.name}}:{{pc.child.name}}
                                    </span>
                                </div>
                            </div>
                            <div class="po-item-price">{{orderItem.price}}</div>
                            <div class="po-item-quant">x {{orderItem.quant}}</div>
                        </div>
                    </div>

                    <div class="po-order-msgs">
                        <div class="po-buyer-msg">{{lang.order.buyerMsg}}: {{item.userMsg}}</div>
                        <div class="po-shop-msg">{{lang.order.shopMsg}}: <span class="po-shop-msg-text">{{item.shopMsg}}</span></div>
                    </div>

                    <div class="po-order-footer">
                        <router-link :to="{name:'orderDetail',query:{orderId:item.id}}" class="po-order-link">
                            <span class="po-order-state">{{lang.stateLabels.order[item.stateCode]}}</span>
                            <span class="glyphicon glyphicon-chevron-right po-chevron"></span>
                            <span class="po-btn-detail">{{lang.order.detail}}</span>
                        </router-link>
                    </div>

                </div>
            </div>
        </paged-loading>
    </div>
</template>
<script>
    import pagedLoading from '../components/base/PagedLoading.vue';
    import queryString from '../utl/queryString';
    import modal from './base/Modal.vue';

    export default {
        components: {
            pagedLoading: pagedLoading,
            modal: modal
        },
        data: function () {
            return {
                paging: { page: 1, pageSize: 1, count: 1 },
                loadingImg: false,
                items: [],
                selectedOrder: null
            };
        },
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.ordersApiClient;
            },
            lang: function () {
                return this.$store.getters.lang;
            }
        },
        methods: {
            reloadItems: function () {
                var obj = { uid: this.userId };
                this.loadItems(queryString().getString(obj));
            },
            onPageChange: function (newPage) {
                var obj = { page: newPage };
                this.loadItems(queryString().getString(obj));
            },
            loadItems: function (query) {
                this.items = [];//set items empty as user session may expired
                this.loadingImg = true;
                this.apiClient.getOrderListPrms(query).done((ret) => {
                    this.loadingImg = false;
                    var filter = ret.filter;
                    this.paging = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                    this.items = ret.items;

                }).fail((ret) => {
                    this.loadingImg = false;
                });
            }
        },
        created: function () {
            this.apiClient.onLoginApi.on(this.reloadItems);
            this.reloadItems();
        },
        destroyed: function () {
            this.apiClient.onLoginApi.remove(this.reloadItems);
        },
        mounted: function () {

        }
    }
</script>